<template>
  <div class="wrapper">
    <div style="margin-bottom:20px;">
      <el-button
        @click="handleEdit('',0)"
        type="primary"
        icon="el-icon-plus"
        v-auth="'sys:company:add'"
      >{{$t('common.addNew')}}</el-button>
    </div>
    <el-table
      v-loading="loading"
      border

      :data="companyLists"
      style="width: 100%"
    >
      <el-table-column :label="$t('common.date')" width="180">
        <template slot-scope="scope">
          <i class="el-icon-time"></i>
          <span style="margin-left: 10px">{{ scope.row.createDate }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="'第三方id'" width="180">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.thirdPartyId }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('thisCompany.companyName')" width="180">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="code" width="180">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.code }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="state" :label="$t('common.status')" width="120" align="center">
        <template scope="scope">
          <el-button type="text"  v-if="scope.row.status==2" plain>{{$t("common.stop")}}</el-button>
          <el-button type="text"  v-if="scope.row.status==1" plain>{{$t("common.start")}}</el-button>
        </template>
      </el-table-column>
      <el-table-column :label="$t('common.handle')">
        <template slot-scope="scope">
          <el-button size="mini" v-auth="'sys:company:bindGate'"  @click="bindingRoutes(scope.row)">{{$t('company.bandGate')}}</el-button>
          <el-button size="mini" v-auth="'sys:company:edit'"     @click="handleEdit(scope.row,1)">{{$t("common.edit")}}</el-button>
          <el-button size="mini" v-auth="'sys:company:resetKey'"  @click="resetAppkey(scope.row)">{{$t('company.resetKey')}}</el-button>
          <el-button
            type="info"
            size="mini"
            @click="blockUp(scope.row)"
            v-if="scope.row.status==1 && userInfo.companyId != scope.row.id"
          >{{$t("common.stop")}}</el-button>
          <el-button
            type="success"
            size="mini"
            @click="startUsing(scope.row)"
            v-if="scope.row.status==2 && userInfo.companyId != scope.row.id"
          >{{$t("common.start")}}</el-button>
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)"
            v-if="userInfo.companyId != scope.row.id"
          >{{$t("common.delete")}}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 编辑弹窗 -->
    <el-dialog :title="titleName" :visible.sync="showEditBox" v-if="showEditBox">
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="第三方id"  :label-width="formLabelWidth">
          <el-input v-model="form.thirdPartyId" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="code" prop="code" :label-width="formLabelWidth">
          <el-input v-model="form.code" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('thisCompany.companyName')"
          prop="name"
          :label-width="formLabelWidth"
        >
          <el-input v-model="form.name" auto-complete="off"></el-input>
        </el-form-item>

        <el-form-item :label-width="formLabelWidth" label="项目选择" prop="moduleName">
          <el-select

            multiple
            :placeholder="$t('login.choiceProject')"
            v-model="moduleName"
          >
            <el-option
              v-for="item in projectArr"
              :key="item.id"
              :disabled="item.disabled"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" label="语言选择" prop="langcheckList">
          <el-checkbox-group v-model="langcheckList">
            <el-checkbox label="zh_CN"></el-checkbox>
            <el-checkbox label="en_US"></el-checkbox>
            <el-checkbox label="vi_VN"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancleSubmit">{{$t("common.cancel")}}</el-button>
        <el-button type="primary" @click="submitData('form')">{{$t("common.ok")}}</el-button>
      </div>
    </el-dialog>
    <div style="margin-top:20px;text-align:right">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10,20,50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalSize"
      ></el-pagination>
    </div>
    <el-dialog :title="$t('gateWay.Gateway')" :visible.sync="gatewayBox">
      <el-tree
        :data="gatewayListData"
        :props="defaultProps"
        ref="gatewayTree"
        show-checkbox
        node-key="id"
        :default-expanded-keys="expandKeys"
        :default-checked-keys="checkedKey"
        :expand-on-click-node="false"
      ></el-tree>
      <div slot="footer" class="dialog-footer">
        <el-button @click="gatewayBox = false">{{$t("common.cancel")}}</el-button>
        <el-button type="primary" @click="submitRoleData">{{$t("common.ok")}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { localRead } from "@/utils/tools";
import { companyBindingRoutes, allgatewayList } from "@/api/sys/gateway.js";
import { getModules } from "@/api/user.js";
import {
  companyList,
  editcompanyList,
  addcompanyList,
  delcompanyList,
  companyStatus,
  resetAppkey
} from "@/api/sys/mycompany";
import { Message, MessageBox } from "element-ui";
import { getAllNode, getAllKey } from "@/utils/tree.js";
import { validUsernames } from "@/utils/validate.js";
var vm = this;
export default {
  data() {
    let check = (rule, value, callback) => {
      if (this.moduleName.length === 0) {
        callback(new Error(this.$t("common.rulesText")));
      } else {
        callback();
      }
    };
    let checkLanguage = (rule, value, callback) => {
      if (this.langcheckList.length === 0) {
        callback(new Error(this.$t("common.rulesText")));
      } else {
        callback();
      }
    };
    return {
      userInfo: JSON.parse(
        localRead(this.$route.query.label + "_sys_userInfo")
      ),
      loading: true,
      titleName: this.$t("common.edit"),
      companyLists: [],
      showEditBox: false,
      changeType: 1, //表示编辑
      formLabelWidth: "150px",
      currentPage: 1,
      pageSize: 10,
      totalSize: 0,
      form: {
        thirdPartyId: 0,
        code: "",
        id: 0,
        name: "",
        modelId: [],
        language: []
      },
      langcheckList: [],
      defaultProps: {
        children: "children",
        label: "label"
      },
      comName: [],
      moduleName: [],
      gatewayListData: [],
      checkedKey: [],
      expandKeys: [],
      companyChackList: "",
      gatewayBox: false,
      companyId: "",
      projectArr: [],
      rules: {
        name: [
          {
            required: true,
            message: this.$t("common.rulesText"),
            trigger: "blur"
          }
        ],
        code: [
          {
            required: true,
            message: this.$t("common.rulesText"),
            trigger: "blur"
          }
        ],
        moduleName: [
          {
            required: true,
            message: this.$t("common.rulesText"),
            trigger: "change",
            type: "array",
            validator: check
          }
        ],
        langcheckList: [
          {
            type: "array",
            required: true,
            message: "请至少选择一种语言",
            trigger: "change",
            validator: checkLanguage
          }
        ]
      }
    };
  },
  mounted() {
    this.getcompanyList();
    this.getAllGatewayList();
  },
  methods: {
    cancleSubmit() {
      this.showEditBox = false;
    },
    getAllSysModules() {
      let companyId = this.userInfo.companyId;
      getModules(companyId).then(res => {
        this.projectArr = res.result;
      });
    },
    getcompanyList() {
      companyList().then(res => {
        this.companyLists = res.result.list;
        this.totalSize = res.result.total;
        this.loading = false;
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetField();
    },

    getAllGatewayList() {},
    editId(idData) {
      let arr = [];
      for (let i in idData) {
        arr.push(idData[i].id);
      }
      return arr;
    },
    handleEdit(row, type) {
      //获取公司相关的项目
      this.getAllSysModules();
      let updateObject;
      updateObject = Object.assign({}, row);
      this.changeType = type;
      if (this.changeType == 1) {

        this.moduleName = this.editId(updateObject.modelId);

        if(updateObject.language != null){
           this.langcheckList = updateObject.language.split(',');
        }else{
          this.langcheckList = []
        }
        this.form = updateObject;
        this.titleName = this.$t("common.edit");
      } else {

        this.moduleName = []
        this.langcheckList = []
        for (let key in this.form) {
          this.form[key] = "";
        }

        this.titleName = this.$t("common.addNew");
      }
      this.showEditBox = true;
    },
    resetAppkey(row) {
      let data = {
        id: row.id
      };

      this.$confirm("确定重新生成, 是否继续?", "提示", {
        confirmButtonText: this.$t("common.ok"),
        cancelButtonText: this.$t("common.cancel"),
        type: "warning",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            resetAppkey(data).then(res => {
              if (res.code == 0) {
                // this.getcompanyList();
              }
            });
            done();
          } else {
            done();
          }
        }
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "生成成功!"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    changeStatus(pram) {
      let data = {
        id: pram.id,
        status: pram.status
      };
      companyStatus(data).then(res => {
        if (res.code == 0) {
          console.log("更改成功");
        }
      });
    },
    startUsing(row) {
      row.status = 1;
      this.changeStatus(row);
    },
    blockUp(row) {
      row.status = 2;
      this.changeStatus(row);
    },
    handleDelete(index, row) {
      this.$confirm("是否删除该公司?", "提示", {
        confirmButtonText: this.$t("common.ok"),
        cancelButtonText: this.$t("common.cancel"),
        type: "warning",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            delcompanyList(row.id).then(res => {
              if (res.code == 0) {
                this.$message({
                  type: "success",
                  message: this.$t("common.conDelete")
                });
                this.getcompanyList();
              }
            });
            done();
          } else {
            done();
          }
        }
      }).catch(() => {
        this.$message({
          type: "info",
          message: this.$t("common.canDele")
        });
      });
    },
    submitData(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          //项目选择
          this.form.modelId = [];
          for (let i in this.moduleName) {
            this.form.modelId.push(this.moduleName[i]);
          }
          this.form.modelId = String(this.form.modelId);
          //语言
          this.form.language = [];
          for (let i in this.langcheckList) {
            this.form.language.push(this.langcheckList[i]);
          }
          this.form.language = String(this.form.language);
          if (this.changeType == 1) {
            editcompanyList(this.form).then(res => {
              if (res.code == 0) {
                Message({
                  message: this.$t("common.changeSu"),
                  type: "success"
                });
              }
              this.getcompanyList();
            });
          } else {
            addcompanyList(this.form).then(res => {
              if (res.code == 0) {
                Message({
                  message: this.$t("common.addSu"),
                  type: "success"
                });
              }
              this.getcompanyList();
            });
          }

          this.showEditBox = false;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getcompanyList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getcompanyList();
    },
    submitRoleData(formName) {
      let data = {
        routes: this.$refs.gatewayTree.getCheckedKeys(),
        companyId: this.companyId
      };
      this.gatewayBox = false;
      companyBindingRoutes(data).then(res => {
        if (res.code == 0) {
          Message({
            message: this.$t("common.changeSu"),
            type: "success"
          });
        }
      });
    },
    bindingRoutes(row) {
      this.gatewayBox = true;
      this.companyId = row.id;
      allgatewayList(row.id).then(res => {
        this.gatewayListData = res.result;
        this.expandKeys = getAllNode(this.gatewayListData, "id", "children");
        this.$refs.gatewayTree.setCheckedKeys(
          getAllKey(this.gatewayListData, "id", "children"),
          true
        );
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.wrapper {
  margin: 50px;
  border: 1px solid #ebebeb;
  border-radius: 3px;
  transition: 0.2s;
  padding: 20px;
}
.none {
  display: none !important;
}
</style>
